package top.wcpe.allincore.dsl.compiler.semantic.`native`.methods

import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.semantic.`native`.Arity
import top.wcpe.allincore.dsl.compiler.semantic.`native`.MethodDescriptor
import top.wcpe.allincore.dsl.compiler.semantic.`native`.ResolveCtx

/**
 * 内置 object {@code session} 的方法占位描述符集合。
 *
 * <p>session.x 字段读写不走 MemberCall（编译期被识别为 SessionRef / SessionAssign）。
 * 仅命令式方法 session.clear() 通过本表登记。</p>
 */

/** session.clear()。 */
object SessionClearMethod : MethodDescriptor {
    override val name: String = "clear"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

val SessionApiMethodMap: Map<String, MethodDescriptor> = listOf(
    SessionClearMethod,
).associateBy { it.name }
